<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row class="row pt-12 mt-sm-20">
        <v-col sm="12" md="7" lg="7" class="">
          <h2>Cloud Strategy & Infrastructure Planning for Marine Companies</h2>
          <p class="jo-class">
            Optimize, Scale & Secure Your Marine IT Infrastructure with Maritech
            Software Pte. Ltd.
            <br />
            Navigating Cloud Complexity Made Simple.
            <br />
            At Maritech Software Pte. Ltd., we understand the unique challenges
            of marine companies when it comes to IT infrastructure. Our
            specialized services are tailored to optimize your cloud strategy,
            ensuring seamless operations, robust security, and future-ready
            scalability—all while reducing costs.
          </p>
          <v-img
            :src="require('@/assets/managed-cloud.webp')"
            class="white--text img"
          />

          <v-divider class=""></v-divider>

          <div>
            <h2 class="pt-5">Our Services</h2>
            <v-list dense class="jo-class">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon large color="#1976d2">mdi-database</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <b>Server Landscape Planning</b>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Evaluate your existing infrastructure.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Optimize performance, uptime, and redundancy.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Create a comprehensive server architecture tailored to meet
                  marine-specific needs.
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-list dense class="jo-class">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon large color="#1976d2">mdi-cloud-sync</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <b>Cloud Migration Services</b>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Migrate your applications and data seamlessly to the cloud.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Minimize downtime and data loss with expert migration
                  planning.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Choose the right Azure or AWS services for your unique
                  business demands.
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-list dense class="jo-class">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon large color="#1976d2">mdi-arrow-expand</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <b>Right-Sizing for Scalability</b>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Optimize infrastructure resources for cost-effective
                  scalability.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Design for future growth with flexibility.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Monitor and fine-tune resource allocation to meet changing
                  demands.
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-list dense class="jo-class">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon large color="#1976d2">mdi-server-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <b>Application Hosting & Provisioning</b>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Customized hosting solutions to ensure peak performance and
                  availability.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Leverage containerization and microservices architecture where
                  applicable.
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="pl-10">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-anchor</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Quick and reliable application provisioning on AWS and Azure.
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>

          <div>
            <h2 class="pt-2">Why Choose Maritech Software Pte. Ltd.?</h2>
            <v-row align="top" no-gutters class="pt-4">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-cogs</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Specialized Expertise in Marine IT Needs</p>
                <p class="description">
                  Our deep understanding of the marine industry ensures tailored
                  cloud solutions that address both current challenges and
                  future demands.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-cube</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Azure & AWS Cloud Specialists</p>
                <p class="description">
                  With vast experience in both Azure and AWS environments, we
                  bring cutting-edge solutions to every project, maximizing your
                  cloud capabilities.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-currency-usd</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Cost Optimization & Security First Approach</p>
                <p class="description">
                  Our focus is on reducing operational costs while ensuring data
                  security and compliance with industry regulations.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-cog</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Seamless Integration & Scalability</p>
                <p class="description">
                  Your evolving business needs are at the heart of our planning,
                  providing you with adaptable and reliable solutions..
                </p>
              </v-col>
            </v-row>
          </div>

          <div>
            <v-divider class="my-4"></v-divider>
            <h2>Contact Us</h2>
            <p class="jo-class">
              <b>Ready to future-proof your marine IT infrastructure?</b>
              <br />
              Speak with our cloud experts today and embark on a journey towards
              efficiency, scalability, and excellence.
            </p>

            <!-- <v-btn
              color="primary"
              class="custom-button"
              elevation="3"
              @click="handleClick"
            >
              Contact Us Button
            </v-btn> -->
          </div>
        </v-col>

        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({
    heading: "Managed Cloud Services"
  }),

  methods: {
    apply() {
      window.location.href = "mailto:kenwyn@maritechsoftware.com";
    }
  }
};
</script>

<style scoped>
h3 {
  color: #033261;
  margin-bottom: 10px;
}

h2 {
  color: #033261;
}

.jo-class {
  margin-bottom: 15px;
}

.heading {
  font-weight: bold;
}

.icon-background {
  background-color: #c4e1f8;
  border-radius: 50%;
  padding: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  color: #080808;
  font-weight: bold;
  margin: 0;
}

.titel {
  font-size: 18px;
}

.description {
  color: #333333;
  margin: 0;
}

/* .icon-background {
  background-color: #E6F4FF;
  border-radius: 50%;
  padding: 8px;
} */

.custom-button {
  font-size: 18px;
  font-weight: bold;
  color: white;
  background: linear-gradient(135deg, #42a5f5, #1976d2);
  border-radius: 25px;
  padding: 12px 24px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0px 8px 15px rgba(30, 136, 229, 0.4);
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}
@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}
</style>
